<template>
    <div v-if="summary" class="text-nowrap" v-b-tooltip.hover :title="tooltipText">
        <span class="badge badge-pill" :class="badgeClass">
            {{ summary.SuccessfulDays }} / {{ summary.ExpectedDays }}
        </span>
    </div>
    <span v-else class="text-muted">-</span>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
    directives: {
        'b-tooltip': VBTooltip,
    },
    props: {
        row: Object,
        field: Object,
    },
    computed: {
        summary() {
            return this.field || this.row?.RowSummary
        },
        ratio() {
            if (!this.summary || !this.summary.ExpectedDays) return 1
            return this.summary.SuccessfulDays / this.summary.ExpectedDays
        },
        badgeClass() {
            if (!this.summary || !this.summary.ExpectedDays) return 'badge-light-secondary'
            if (this.ratio >= 0.9) return 'badge-light-success'
            if (this.ratio >= 0.6) return 'badge-light-warning'
            return 'badge-light-danger'
        },
        tooltipText() {
            if (!this.summary) return ''
            const s = this.summary
            const parts = []
            if (s.SuccessfulDays) parts.push(`Başarılı: ${s.SuccessfulDays}`)
            if (s.DownloadedNotProcessedDays) parts.push(`İşlenemedi: ${s.DownloadedNotProcessedDays}`)
            if (s.FileAlreadyDownloadedDays) parts.push(`Zaten İndirilmiş: ${s.FileAlreadyDownloadedDays}`)
            if (s.DownloadFailedDays) parts.push(`İndirilemedi: ${s.DownloadFailedDays}`)
            if (s.QueryFailedDays) parts.push(`Sorgu Başarısız: ${s.QueryFailedDays}`)
            if (s.NotQueriedDays) parts.push(`Sorgulanmadı: ${s.NotQueriedDays}`)
            if (s.NotConfiguredDays) parts.push(`Yapılandırma Eksik: ${s.NotConfiguredDays}`)
            return parts.join(' · ')
        },
    },
}
</script>
